/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ReferencedPersonNameDTO } from './ReferencedPersonNameDTO';
import {
    ReferencedPersonNameDTOFromJSON,
    ReferencedPersonNameDTOFromJSONTyped,
    ReferencedPersonNameDTOToJSON,
    ReferencedPersonNameDTOToJSONTyped,
} from './ReferencedPersonNameDTO';
import type { ExternalIdDTO } from './ExternalIdDTO';
import {
    ExternalIdDTOFromJSON,
    ExternalIdDTOFromJSONTyped,
    ExternalIdDTOToJSON,
    ExternalIdDTOToJSONTyped,
} from './ExternalIdDTO';

/**
 * 
 * @export
 * @interface ReferencedPersonDTO
 */
export interface ReferencedPersonDTO  {
    /**
     * 
     * @type {number}
     * @memberof ReferencedPersonDTO
     */
    id?: number;
    /**
     * 
     * @type {Array<ReferencedPersonNameDTO>}
     * @memberof ReferencedPersonDTO
     */
    personNames?: Array<ReferencedPersonNameDTO>;
    /**
     * 
     * @type {Array<ExternalIdDTO>}
     * @memberof ReferencedPersonDTO
     */
    externalIds?: Array<ExternalIdDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferencedPersonDTO
     */
    topOrgas?: Array<string>;
}

/**
 * Check if a given object implements the ReferencedPersonDTO interface.
 */
export function instanceOfReferencedPersonDTO(value: object): value is ReferencedPersonDTO {
    return true;
}

export function ReferencedPersonDTOFromJSON(json: any): ReferencedPersonDTO {
    return ReferencedPersonDTOFromJSONTyped(json, false);
}

export function ReferencedPersonDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferencedPersonDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
              'personNames': json['personNames'] == null ? undefined : ((json['personNames'] as Array<any>).map(ReferencedPersonNameDTOFromJSON)),
              'externalIds': json['externalIds'] == null ? undefined : ((json['externalIds'] as Array<any>).map(ExternalIdDTOFromJSON)),
              'topOrgas': json['topOrgas'] == null ? undefined : json['topOrgas'],
    };
}

export function ReferencedPersonDTOToJSON(json: any): ReferencedPersonDTO {
    return ReferencedPersonDTOToJSONTyped(json, false);
}

export function ReferencedPersonDTOToJSONTyped(value?: ReferencedPersonDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'personNames': value['personNames'] == null? value['personNames']: (value['personNames'] as Array<any>).map(ReferencedPersonNameDTOToJSON),
        'externalIds': value['externalIds'] == null? value['externalIds']: (value['externalIds'] as Array<any>).map(ExternalIdDTOToJSON),
        'topOrgas': value['topOrgas'] == null? value['topOrgas']: value['topOrgas'],
    };
}


